/**
 * The side menu's and the user menu's pure pieces (CU-869fmherf). Pure and alias-free, so `node --test`
 * runs them; the paths come from `USER_ROUTES` at the call site.
 */

// What the three nav views paint as a separator (`Nav/NavSection/Vertical`, `Mini`, `PopoverNav`)
export const MENU_DIVIDER = Object.freeze({ path: 'divider' })

/**
 * The user menu's links between Home and Logout (D2): Settings for everyone, Iris settings for Iris's
 * users. `iris: true` asks the caller for Iris's mark as the icon.
 */
export function userMenuLinks({ isIris, settingsPath, irisPath }) {
	return [
		{ url: settingsPath, icon: 'gear', text: 'Settings' },
		...(isIris ? [{ url: irisPath, iris: true, text: 'Iris settings' }] : []),
	]
}

/**
 * The menu with a separator right above User Settings, so the settings (User Settings, Admin) sit apart
 * at the end (D5). Applied to the menu only, after the feature filter: it never reaches `useRoutes` and
 * needs no `id`. Nothing above User Settings, no User Settings or a divider already there: unchanged.
 */
export function withSettingsDivider(routes, beforePath) {
	const at = routes.findIndex(r => r.path === beforePath)
	if (at <= 0 || routes[at - 1]?.path === MENU_DIVIDER.path) return routes
	return [...routes.slice(0, at), MENU_DIVIDER, ...routes.slice(at)]
}
